import { 
    CreatePackageAccommodationDto, 
    DeletePackageAccommodationDto,
    EditPackageAccommodationDto,
    GetPackageAccommodationDto, 
    MessageResponseDto, 
    PackageAccommodationApiFp,
    PackageAccommodationControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponsePackageAccommodationModel = PackageAccommodationControllerGet200Response;
export type GetPackageAccommodationModel = GetPackageAccommodationDto;
export type MutateResponsePackageAccommodationModel = MessageResponseDto;
export type CreatePackageAccommodationModel = CreatePackageAccommodationDto;
export type UpdatePackageAccommodationModel = EditPackageAccommodationDto;
export type DeletePackageAccommodationModel = DeletePackageAccommodationDto;

export const apiPackageAccommodationFp = PackageAccommodationApiFp(apiConfig);
export const getPackageAccommodationController = apiPackageAccommodationFp.packageAccommodationControllerGet;
export const createPackageAccommodationController = apiPackageAccommodationFp.packageAccommodationControllerCreate;
export const updatePackageAccommodationController = apiPackageAccommodationFp.packageAccommodationControllerEdit;
export const deletePackageAccommodationController = apiPackageAccommodationFp.packageAccommodationControllerDelete;

export const QueryKeyPackageAccommodation = QueryKey.PackageAccommodation;